import { Component, inject, OnInit } from '@angular/core';
import createDebug from 'debug';
import { SchemaFormsService } from '@apexdesigner/schema-forms';
import { AuthService } from './services/auth/auth.service';
import { ComponentService } from './services/component/component.service';
import { AsyncPipe } from '@angular/common';
import { MatAnchor } from '@angular/material/button';
import { MatToolbar } from '@angular/material/toolbar';
import { RouterLink, RouterOutlet } from '@angular/router';
import { FlexColumnComponent, GrowDirective } from '@apexdesigner/flex-layout';
import { AvatarComponent } from '@components/avatar/avatar.component';

const Debug = createDebug('AppComponent');

/**
 * App
 *
 * Root application component.
 */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    AsyncPipe,
    AvatarComponent,
    FlexColumnComponent,
    GrowDirective,
    MatAnchor,
    MatToolbar,
    RouterLink,
    RouterOutlet,
  ],
})
export class AppComponent implements OnInit {
  authService = inject(AuthService);

  private schemaFormsService = inject(SchemaFormsService);

  componentService = inject(ComponentService);

  /** Whether to show the Home link. */
  showHome: boolean = false;

  /** Whether to show admin links. */
  showAdmin: boolean = false;

  /** Whether to show process admin link. */
  showProcessAdmin: boolean = false;

  /** Whether to show configuration link. */
  showConfiguration: boolean = false;

  /** Register Fields - Register schema form fields from component metadata */ registerFields(): void {
    const debug = Debug.extend('registerFields');
    for (const meta of this.componentService.metadata) {
      if (meta.metadata?.schemaFormsField) {
        const fieldName = meta.selector.replace(/-field$/, '');
        this.schemaFormsService.registerField(fieldName, () =>
          this.componentService.loadComponent(meta.name),
        );
      }
    }
    debug('this.schemaFormsService', this.schemaFormsService);
  }

  /** Check user roles and set toolbar visibility. */

  async initialize(): Promise<void> {
    const debug = Debug.extend('initialize');
    debug('top');
    const currentUser = await this.authService.getCurrentUser();
    debug('currentUser', currentUser);

    const roles = currentUser?.roleAssignments || [];
    const hasNoRoles = roles.length === 0;
    const isCandidate = await this.authService.hasRole('Candidate');

    this.showHome = hasNoRoles || isCandidate;
    this.showAdmin = !hasNoRoles && !isCandidate;
    this.showProcessAdmin = await this.authService.hasRole(
      'ProcessAdministrator',
    );
    this.showConfiguration = await this.authService.hasRole('Configurator');
    debug('this.showHome', this.showHome);
    debug('this.showAdmin', this.showAdmin);
    debug('this.showProcessAdmin', this.showProcessAdmin);
    debug('this.showConfiguration', this.showConfiguration);
  }

  ngOnInit(): void {
    this.registerFields();
    this.initialize();
  }
}
